import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {DialogModel} from '@shared/models/dialog.model';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {PlatformQueryService} from '@core/services/platform-query.service';
import {DialogService} from '@shared/services/dialog-service';
import {CommandService} from '@core/services/command.service';
import {Api} from '@shared/constants/common-field.constants';
import {take} from 'rxjs/operators';
import {PlatformQuery} from '@shared/models/platform-query/platform-query';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {ExpertServiceFirm, ExpertServiceInfo, ExpertServiceTemplate} from '../../models/expert-services.model';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
    standalone: false,
    selector: 'app-create-expert-services-dialog',
  templateUrl: './create-expert-services-dialog.component.html',
  styleUrls: ['./create-expert-services-dialog.component.scss']
})
export class CreateExpertServicesDialogComponent implements OnInit, IDialogView, OnDestroy {
  data: DialogModel;
  expertServiceFirms: ExpertServiceFirm[];
  expertServiceTemplates: ExpertServiceTemplate[];

  selectorForm: FormGroup;

  constructor(private platformQueryService: PlatformQueryService,
              private formBuilder: FormBuilder,
              @Inject(MAT_DIALOG_DATA) public dialogInfo: DialogModel) {
  }

  ngOnInit(): void {
    this.data.isDisabledOkButton = true;
    this.selectorForm = this.formBuilder.group({
      expertServiceTitle: ['', Validators.required],
      expertServiceDescription: [''],
      expertServiceFirm: ['', [Validators.required]],
      selectedTemplate: ['', [Validators.required]],
    });
    this.getExpertServiceFirms();
    this.selectorForm.valueChanges.subscribe(() => {
      this.data.isDisabledOkButton = this.selectorForm.invalid;
    });
    this.selectorForm.get('expertServiceFirm').valueChanges.subscribe(res => {
      this.mapWithSelectedData(res.firmId);
    });
  }

  onOkClicked(): boolean {
    if (this.selectorForm.valid) {
      this.data.input.expertServiceTittle = this.selectorForm.get('expertServiceTitle').value;
      this.data.input.expertServiceDescription = this.selectorForm.get('expertServiceDescription').value;
      this.data.input.expertServiceFirm = this.selectorForm.get('expertServiceFirm').value;
      this.data.input.selectedTemplate = this.selectorForm.get('selectedTemplate').value;
      return true;
    }
    return false;
  }

  private getExpertServiceFirms() {
    const query = new PlatformQuery();
    query.name = 'ExpertServiceFirmQuery';
    query.api = Api.MarketPlace;
    this.platformQueryService.executeQuery(query).pipe(take(1)).subscribe(response => {
      if (response && response.fieldValues) {
        this.expertServiceFirms = response.fieldValues['ExpertServiceFirms'];
      }
    });
  }

  private mapWithSelectedData(expertServiceFirmId: string) {
    const query = new PlatformQuery();
    query.name = 'ExpertServiceTemplatesQuery';
    query.api = Api.MarketPlace;
    query.setValue('ExpertServiceFirmId', expertServiceFirmId);
    this.platformQueryService.executeQuery(query).pipe(take(1)).subscribe(response => {
      if (response && response.fieldValues) {
        this.expertServiceTemplates = response.fieldValues['ExpertServiceTemplates'];
        this.selectorForm.get('selectedTemplate').patchValue('', {onlySelf: true, emitEvent: false});
        this.dialogInfo.isDisabledOkButton = true;
      }
    });
  }

  onCancelClicked(): any {
  }

  ngOnDestroy(): void {
  }
}
